import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BsExclamationTriangleFill } from 'react-icons/bs';
const ConfirmDialog = ({
  show,
  title,
  message,
  onConfirm,
  onCancel
}) => {
  return <Modal show={show} onHide={onCancel} centered>
              <div style={{
      backgroundColor: "var(--black2)",
      borderRadius: "8px"
    }}>
   
 


            <Modal.Header closeButton className=" border-0">
                <Modal.Title className="d-flex align-items-center gap-2 text-danger">
                    <BsExclamationTriangleFill size={22} />
                    {title || 'Confirm Action'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center py-4 text-white">
                <p className="fs-5 fw-semibold">{message || 'Are you sure you want to proceed?'}</p>
            </Modal.Body>

            <Modal.Footer className="border-0 d-flex justify-content-center gap-3">
                <Button variant="btn btn-outline-danger" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="success" onClick={onConfirm}>
                    Confirm
                </Button>
            </Modal.Footer>

             </div>
        </Modal>;
};
export default ConfirmDialog;
